import React, { useEffect, useState } from 'react'
import { Pressable, ScrollView, StyleSheet, Text, View } from 'react-native'

import { DS } from '@/design-system'

import { observer } from 'mobx-react-lite'

import { router } from 'expo-router'

import { useQuery } from 'convex/react'
import { api } from '@ppwr/convex/_generated/api'

import { useAvatarStore, useUser } from "@/screens/profile-screen/edit/AvatarModule"
import { Avatars } from "@/screens/profile-screen/edit/assets"
import type { BotSkillLevel } from '@ppwr/poker-engine/utils'

import AvatarBotCasual from "@/screens/profile-screen/edit/assets/Bot_Casual.svg"
import AvatarBotExpert from "@/screens/profile-screen/edit/assets/Bot_Expert.svg"
import AvatarBotNovice from "@/screens/profile-screen/edit/assets/Bot_Novice.svg"
import AvatarBotRegular from "@/screens/profile-screen/edit/assets/Bot_Regular.svg"

// Only Avatar0 (the initials fallback) actually reads `name`; the other
// illustrated avatars ignore unknown props at runtime, but don't declare
// `name` in their individual (strict) prop types, hence this cast.
type AvatarComponent = React.ComponentType<{
  colors?: Record<string, string | undefined>
  size?: number | string
  name?: string
}>

function AvatarBuilder(){

  const setError = useAvatarStore(s => s.setError)

  useEffect(() => {
    setError(null)
  }, [])

  return (
    <View style={{flex: 1, gap: 24, borderRadius: 16, padding: 24, backgroundColor: DS.palette['Global/White']}}>
      <View style={{alignSelf: "center"}}>
        <AvatarIcon />
      </View>

      <ScrollView style={{flex: 1}} showsVerticalScrollIndicator={false}>
        <View style={{gap: 24}}>
          {/*<View style={{alignSelf:"flex-end"}}>
            <AvatarControls />
          </View>*/}
          <AvatarChooser />
          <BackgroundColorChooser />
          <HairColorChooser />
          <SkinColorChooser />
          <AccessoriesColorChooser />
        </View>
      </ScrollView>
    </View>
  )
}

function AvatarControls(){
  

  const setSelectedToSaved = useAvatarStore(s => s.setSelectedToSaved)

  function handleCancel(){
    setSelectedToSaved()
  }

  function handleClick(){
    alert ("only cancel active. convex mutations for others exist but not tested yet")
  }

  return (
    <View style={{flexDirection: "row", gap: 8}}>
      <Pressable onPress={handleClick}>
        <Text style={{textDecorationLine: 'underline', color: "blue"}}>
          Reset
        </Text>
      </Pressable>
      <Pressable onPress={handleClick}>
        <Text style={{textDecorationLine: 'underline', color: "blue"}}>Save</Text>
      </Pressable>
      <Pressable onPress={handleCancel}>
        <Text style={{textDecorationLine: 'underline', color: "blue"}}>
          Cancel
        </Text>
      </Pressable>
    </View>
  )
}







function AvatarChooser(){

  const { userName } = useUser()

  const selectedAvatarId = useAvatarStore(s => s.selectedAvatarId)
  const setSelectedAvatarId = useAvatarStore(s => s.setSelectedAvatarId)
  const setSelectedToDefaults = useAvatarStore(s => s.setSelectedToDefaults)

  const background = useAvatarStore(s => s.defaultBackgroundColor)
  const hair = useAvatarStore(s => s.defaultHairColor)
  const skin = useAvatarStore(s => s.defaultSkinColor)
  const defaultBackgroundColor = useAvatarStore(s => s.defaultBackgroundColor)
  const txt = (background == defaultBackgroundColor)
    ? DS.palette['Global/Black']
    : DS.palette['Global/White']

  const colors = {background, hair, skin, txt};

  function handleClick(id: string){
    //setSelectedToDefaults()
    setSelectedAvatarId (id)
  }

  return(
    <ChooserContainer label="Avatars" >
      {Object.entries(Avatars).map(function (avatar){
        const avatarId = avatar[0];
        const Avatar = avatar[1];
        
        const borderColor = (avatarId == selectedAvatarId) ? /*DS.palette["Global/Black"]*/ "black" : "transparent"
        
        return (
          <View key={avatarId}>
            <Pressable onPress={()=>handleClick(avatarId)} style={{width:48, height:48, borderWidth: 2, borderRadius:24, borderColor }}>
              <Avatar colors={colors} size="100%" name={userName}/>
            </Pressable>
            {/*<DS.Text variant="Mini/Regular">{avatarId}</DS.Text>*/}
          </View>
        )
      })}
    </ChooserContainer>
  )
}



function BackgroundColorChooser(){

  const colors = useAvatarStore(s => s.backgroundColors)
  const setColor = useAvatarStore(s => s.setSelectedBackgroundColor)
  const selectedColor = useAvatarStore(s => s.selectedBackgroundColor)
  const label = "Background"

  return (
    <ColorChooser colors={colors} setColor={setColor} selectedColor={selectedColor} label={label}/>
  )
  
}

function HairColorChooser(){

  const colors = useAvatarStore(s => s.hairColors)
  const setColor = useAvatarStore(s => s.setSelectedHairColor)
  const selectedColor = useAvatarStore(s => s.selectedHairColor)
  const label = "Hair"

  return (
    <ColorChooser colors={colors} setColor={setColor} selectedColor={selectedColor} label={label}/>
  )
  
}

function SkinColorChooser(){

  const colors = useAvatarStore(s => s.skinColors)
  const setColor = useAvatarStore(s => s.setSelectedSkinColor)
  const selectedColor = useAvatarStore(s => s.selectedSkinColor)
  const label = "Skin"

  return (
    <ColorChooser colors={colors} setColor={setColor} selectedColor={selectedColor} label={label}/>
  )
}

function AccessoriesColorChooser(){

  const colors = useAvatarStore(s => s.accessoriesColors)
  const setColor = useAvatarStore(s => s.setSelectedAccessoriesColor)
  const selectedColor = useAvatarStore(s => s.selectedAccessoriesColor)
  const label = "Accessories"

  return (
    <ColorChooser colors={colors} setColor={setColor} selectedColor={selectedColor} label={label}/>
  )
  
}

 function ColorChooser(
  {colors, setColor, selectedColor, label}: 
  {colors: string[], setColor: (color: string) => void, selectedColor: string, label: string}) {

  function handleClick(color: string){
    setColor(color)
  }

  return (
    <ChooserContainer label={label}>
      {colors.map(function (color){

        const borderColor = (color == selectedColor) ? "black" : "transparent"

        return (
          <Pressable 
            key={color}
            onPress={()=>handleClick(color)} 
            style={{backgroundColor:color, borderColor, borderWidth:2, width:48, height:48, borderRadius: 24}}
          >
          </Pressable>
        )
      })}
    </ChooserContainer>
  )
}

function ChooserContainer({label, children}: {label: string; children: React.ReactNode}) {
  return (
    <View style={{gap: 8}}>
      <DS.Text variant="Mini/Bold" style={styles.fieldLabel} uppercase>
        {label}
      </DS.Text>
      <View 
        style={{
          borderWidth: 1, 
          borderColor: DS.palette['Brand/Light Grey'], 
          borderRadius: 16,
          padding:16,
        }}
      >
        <ScrollView horizontal showsHorizontalScrollIndicator={false}>
          <View style={{flexDirection: "row", gap: 16}}>
            {children}
          </View>
        </ScrollView>
      </View>
    </View>
  )
}

const AvatarIcon = observer(function AvatarIcon(){

  const { userName } = useUser()

  const avatarId = useAvatarStore(s => s.selectedAvatarId)

  const background = useAvatarStore(s => s.selectedBackgroundColor)
  const hair = useAvatarStore(s => s.selectedHairColor)
  const skin = useAvatarStore(s => s.selectedSkinColor)
  const accessories = useAvatarStore(s => s.selectedAccessoriesColor)

  const defaultBackgroundColor = useAvatarStore(s => s.defaultBackgroundColor)
  const txt = (background == defaultBackgroundColor)
    ? DS.palette['Global/Black']
    : DS.palette['Global/White']

  //const Avatar = Avatars[avatarId]
  const Avatar = Avatars[avatarId as keyof typeof Avatars] as AvatarComponent
  const colors = {background, hair, skin, txt, accessories};

  return (
    <View style={{gap:8}}>
      <Avatar colors={colors} size={200} name={userName} />
      <DS.Text variant="Heading 5/Medium" style={{textAlign: "center"}}>
        {userName}
      </DS.Text>
    </View>
  )

})

/** `plain` renders the avatar with the default (uncoloured) palette instead of the saved one */
function Avatar({ size = 50, plain = false }: { size?: number | string; plain?: boolean }){

  const { userName } = useUser()

  const avatarId = useAvatarStore(s => s.savedAvatarId)

  const background = useAvatarStore(s => plain ? s.defaultBackgroundColor : s.savedBackgroundColor ?? s.defaultBackgroundColor)
  const hair = useAvatarStore(s => plain ? s.defaultHairColor : s.savedHairColor ?? s.defaultHairColor)
  const skin = useAvatarStore(s => plain ? s.defaultSkinColor : s.savedSkinColor ?? s.defaultSkinColor)
  const accessories = useAvatarStore(s => plain ? s.defaultAccessoriesColor : s.savedAccessoriesColor ?? s.defaultAccessoriesColor)
  const defaultBackgroundColor = useAvatarStore(s => s.defaultBackgroundColor)
  const txt = (background == defaultBackgroundColor)
    ? DS.palette['Global/Black']
    : DS.palette['Global/White']

  //const Avatar = Avatars[avatarId]
  const Avatar = Avatars[avatarId as keyof typeof Avatars] as AvatarComponent
  const colors = {background, hair, skin, txt, accessories};

  return (
    <Avatar colors={colors} size={size} name={userName} />
  )
}

function TheirAvatar({ userId, name, size = 50 }: { userId: string; name: string; size?: number }) {

  const preferences = useQuery(api.avatarPreferences.queries.getAvatarPreferences, { userId })

  const defaultAvatarId = useAvatarStore(s => s.defaultAvatarId)
  const defaultBackgroundColor = useAvatarStore(s => s.defaultBackgroundColor)
  const defaultHairColor = useAvatarStore(s => s.defaultHairColor)
  const defaultSkinColor = useAvatarStore(s => s.defaultSkinColor)
  const defaultAccessoriesColor = useAvatarStore(s => s.defaultAccessoriesColor)
  const defaultTxtColor = DS.palette['Global/Black']

  const avatarId = preferences?.avatarId ?? defaultAvatarId
  const background = preferences?.backgroundColor ?? defaultBackgroundColor
  const hair = preferences?.hairColor ?? defaultHairColor
  const skin = preferences?.skinColor ?? defaultSkinColor
  const accessories = preferences?.accessoriesColor ?? defaultAccessoriesColor
  const txt = (background == defaultBackgroundColor)
    ? defaultTxtColor
    : DS.palette['Global/White']


  const Avatar = Avatars[avatarId as keyof typeof Avatars] as AvatarComponent
  const colors = {background, hair, skin, txt, accessories}

  //query has yet to return
  if (preferences === undefined){
    return null
  }

  return (
    <Avatar colors={colors} size={size} name={name} />
  )
}

const BOT_AVATARS: Record<BotSkillLevel, React.ComponentType<{ width?: number; height?: number }>> = {
  novice: AvatarBotNovice,
  casual: AvatarBotCasual,
  regular: AvatarBotRegular,
  expert: AvatarBotExpert
}

function BotAvatar({ skillLevel = 'regular', size = 32 }: { skillLevel?: BotSkillLevel; size?: number }) {

  const BotAvatarComponent = BOT_AVATARS[skillLevel]

  return (
    <BotAvatarComponent width={size} height={size} />
  )
}

export { Avatar, TheirAvatar, BotAvatar, AvatarBuilder }

const styles = StyleSheet.create({
  fieldLabel: {
    color: DS.palette['Brand/Dark Grey'],
    letterSpacing: 0.5
  }
})

